import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const _getters = {
    getSections: state => {
        return state.sections
    },
    getPages: state => {
        return state.pages
    },
    getTweets: state => {
        return state.tweets
    },
    getTestimonials: state => {
        return state.testimonials
    }
}

const store = new Vuex.Store({
    state: {
        sections: [],
        pages: [],
        tweets: [],
        testimonials: []
    },
    mutations: {
        sections (state, sections) {
            state.sections = sections
        },
        pages (state, pages) {
            state.pages = pages
        },
        tweets (state, tweets) {
            state.tweets = tweets
        },
        testimonials (state, testimonials) {
            state.testimonials = testimonials
        }
    },
    getters: _getters
})

export default store
